import { Injectable } from '@angular/core';
import { toastrSeverity } from '../agility-risk.constants';
import { BehaviorSubject } from 'rxjs';
import { Message } from 'primeng/api';

export abstract class AgilityRiskMessageService {
  abstract status: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  abstract success(summary: string, details?: string);

  abstract info(summary: string, details?: string);

  abstract warning(summary: string, details?: string);

  abstract error(summary: string, details?: string);
}

@Injectable()
export class MessageDefaultService implements AgilityRiskMessageService {
  public status: BehaviorSubject<Message> = new BehaviorSubject<Message>({});

  constructor() {
    console.log('message provide loaded');
  }

  success(summary: string, details?: string) {
    this.status.next({
      severity: toastrSeverity.success,
      summary: summary,
      detail: details
    });
  }

  info(summary: string, details?: string) {
    this.status.next({
      severity: toastrSeverity.info,
      summary: summary,
      detail: details
    });
  }

  warning(summary: string, details?: string) {
    this.status.next({
      severity: toastrSeverity.warning,
      summary: summary,
      detail: details
    });
  }

  error(summary: string, details?: string) {
    this.status.next({
      severity: toastrSeverity.error,
      summary: summary,
      detail: details
    });
  }
}

